import React from 'react';
import { Box, Grid, Chip } from '@mui/material';
import { PersonAdd as PersonAddIcon, AdminPanelSettings as AdminIcon } from '@mui/icons-material';

const UserActivityTab = ({ metrics }) => {
  const users = metrics.recentUsers;

  return (
    <Box>
      {/* User Stats */}
      <Grid container spacing={3} sx={{ marginBottom: '24px' }}>
        <Grid item xs={12} md={3}>
          <StatBox label="Total Users" value={metrics.users.total} color="#3B82F6" />
        </Grid>
        <Grid item xs={12} md={3}>
          <StatBox label="Signups Today" value={metrics.users.today} color="#10B981" />
        </Grid>
        <Grid item xs={12} md={3}>
          <StatBox label="This Week" value={metrics.users.last7Days} color="#8B5CF6" />
        </Grid>
        <Grid item xs={12} md={3}>
          <StatBox label="Yesterday" value={metrics.users.yesterday} color="#F59E0B" />
        </Grid>
      </Grid>

      {/* Recent Signups */}
      <Box
        sx={{
          background: '#1E293B',
          border: '1px solid #334155',
          borderRadius: '12px',
          padding: '24px',
        }}
      >
        <Box sx={{ fontSize: '20px', fontWeight: 700, marginBottom: '20px', color: '#3B82F6' }}>
          <PersonAddIcon sx={{ verticalAlign: 'middle', marginRight: '8px' }} />
          Recent User Signups
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {users.map((user, index) => (
            <Box
              key={user.id}
              sx={{
                background: '#0F172A',
                border: '1px solid #334155',
                borderRadius: '8px',
                padding: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                transition: 'all 0.2s',
                '&:hover': {
                  borderColor: '#3B82F6',
                  transform: 'translateX(4px)',
                },
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                  <Box sx={{ fontSize: '16px', fontWeight: 600, color: '#F1F5F9' }}>
                    {user.email}
                  </Box>
                  {user.isAdmin && (
                    <Chip
                      icon={<AdminIcon sx={{ fontSize: '14px' }} />}
                      label="ADMIN"
                      size="small"
                      sx={{
                        background: '#7C3AED',
                        color: '#FFF',
                        fontWeight: 700,
                        fontSize: '10px',
                      }}
                    />
                  )}
                </Box>
                <Box sx={{ fontSize: '13px', color: '#94A3B8' }}>
                  Joined: {new Date(user.createdAt).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </Box>
              </Box>

              <Chip
                label={user.subscriptionStatus.toUpperCase()}
                sx={{
                  background:
                    user.subscriptionStatus === 'active'
                      ? '#065F46'
                      : user.subscriptionStatus === 'past_due'
                      ? '#7F1D1D'
                      : '#374151',
                  color: '#FFF',
                  fontWeight: 700,
                  fontSize: '11px',
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

const StatBox = ({ label, value, color }) => (
  <Box
    sx={{
      background: '#1E293B',
      border: `2px solid ${color}`,
      borderRadius: '12px',
      padding: '24px',
      textAlign: 'center',
      transition: 'all 0.2s',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: `0 8px 24px ${color}44`,
      },
    }}
  >
    <Box sx={{ fontSize: '48px', fontWeight: 700, color, marginBottom: '8px' }}>
      {value}
    </Box>
    <Box sx={{ fontSize: '13px', fontWeight: 600, color: '#94A3B8', textTransform: 'uppercase' }}>
      {label}
    </Box>
  </Box>
);

export default UserActivityTab;
